export const GOOGLE_PLACE_URL = 'https://www.google.com/maps/search/?api=1&query=';
